import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';

class Pause extends Component {
  static propTypes = {
    paused: PropTypes.bool
  }

  render() {
    const { paused } = this.props;

    const componentClassNames = classNames(
      'PauseIcon',
      { 'PauseIcon-paused': paused }
    );

    return (
      <div className={componentClassNames}>
        <div></div>
        <div></div>
      </div>
    );
  }
}

export default Pause;



// WEBPACK FOOTER //
// ./app/components/icons/Pause.js